import React, {Fragment} from 'react';
import {connect} from 'react-redux';
import {Helmet} from 'react-helmet';

// import Header from '@ibibo/react-components/lib/header';
import Header from './gt-react-components/Header';
import {fetchUserDetailsThunk} from '@stencil/user-reducer';

class HeaderWrapper extends React.Component {
  componentDidMount() {
    const {fetchUserDetails} = this.props;
    fetchUserDetails();
  }

  render() {
    const {gocashInfo, userInfo, showLoginPopUp, location} = this.props;
    return (
      <Fragment>
        <Helmet
          link={[
            {
              href: 'https://goibibo.ibcdn.com/styleguide/css/combinedStyles.css',
              rel: 'stylesheet',
              type: 'text/css',
              media: 'all',
            },
          ]}
        />
        <Header
          ref="header"
          location={location}
          gocashInfo={gocashInfo}
          userInfo={userInfo}
          showLoginPopUp={showLoginPopUp}
        />
      </Fragment>
    );
  }
}

function mapStateToProps(state) {
  const {user} = state;
  const {gocashInfo, userInfo, showLoginPopup} = user;
  return {
    gocashInfo,
    userInfo,
    showLoginPopUp: showLoginPopup || true,
    showGobiz: false,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    fetchUserDetails: () => dispatch(fetchUserDetailsThunk()),
  };
}

// function mapDispatchToProps(dispatch) {
//   return {
//     actions: bindActionCreators(
//       Object.assign({}, () => {}),
//       dispatch,
//     ),
//   };
// }

export default connect(mapStateToProps, mapDispatchToProps)(HeaderWrapper);
